import { render } from "./TvmSlideOutServiceSpecial.vue?vue&type=template&id=35e7a7fe&scoped=true"
import script from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"

import "./TvmSlideOutServiceSpecial.vue?vue&type=style&index=0&id=35e7a7fe&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e7a7fe"],['__file',"src/Components/ChatWidget/SlideOutPanel/TvmSlideOutServiceSpecial/TvmSlideOutServiceSpecial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35e7a7fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35e7a7fe', __exports__)) {
    api.reload('35e7a7fe', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutServiceSpecial.vue?vue&type=template&id=35e7a7fe&scoped=true", () => {
    api.rerender('35e7a7fe', render)
  })

}


export default __exports__